import { Fragment } from 'prosemirror-model';
import { findChildren, findParentNodeClosestToPos } from 'prosemirror-utils';
import { findChildTableBody, isTableNode, isTableRowNode } from '..';
import { trackTransactionMetrics } from '../../core';
import { findChildTableRows } from '../utils';
export const removeRow = (state, dispatch, _, attrs = {}) => {
    var _a;
    const { tablePos, rowNumber } = attrs;
    if (tablePos === undefined || rowNumber === undefined)
        return false;
    const tableNode = (_a = findParentNodeClosestToPos(state.doc.resolve(tablePos + 1), isTableNode)) === null || _a === void 0 ? void 0 : _a.node;
    if (!tableNode)
        return false;
    const parentRows = findChildren(tableNode, isTableRowNode);
    const parentBody = findChildTableBody(tableNode)[0];
    const parentRow = parentRows[rowNumber];
    if (!parentRows.length || !parentBody) {
        return false;
    }
    if (findChildTableRows(parentBody.node).length < 2) {
        // there is one row left
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(trackTransactionMetrics(state.tr.replaceWith(tablePos + parentRow.pos, tablePos + parentRow.pos + parentRow.node.nodeSize + 1, Fragment.empty), 'removeRow', { rows: parentRows.length, cols: parentRow.node.childCount }));
    return true;
};
